import { render } from "./RemoveBtn.vue?vue&type=template&id=98ba6348&scoped=true"
import script from "./RemoveBtn.vue?vue&type=script&lang=js"
export * from "./RemoveBtn.vue?vue&type=script&lang=js"

import "./RemoveBtn.vue?vue&type=style&index=0&id=98ba6348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ba6348"]])

export default __exports__